// @flow
import * as React from 'react'
import { FormattedMessage } from 'mz-intl'
import type { Train } from 'mz-sdk/services/train/getTrains'
import OptionItem from '../../../core/Dropdown/OptionItem'
import trainToString from '../utils/trainToString'
import { Container, Header } from './elements'
import messages from '../messages.intl'

// Types
import type { TrainInfo } from '../TrainRootField'

export type Props = {
  trainInfo: TrainInfo,
  onSelectTrain: (Train) => any,
  trains: Train[],
}

class FlightSearchResult extends React.Component<Props> {
  handleSelectTrain = (train: Train) => {
    const { onSelectTrain } = this.props
    onSelectTrain && onSelectTrain(train)
  }

  renderPosibleOptions() {
    if (!this.props.trains.length) {
      return (
        <React.Fragment>
          <Header>
            <FormattedMessage message={messages.TRAIN_OPTIONS} />
          </Header>
          <FormattedMessage tagName="p" message={messages.NO_TRAINS_FOUND} />
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        <Header>
          <FormattedMessage message={messages.TRAIN_OPTIONS} />
        </Header>
        {this.props.trains.map((x, i) => (
          <OptionItem
            key={i}
            value={x}
            renderOption={trainToString}
            onClick={this.handleSelectTrain}
          />
        ))}
      </React.Fragment>
    )
  }

  render() {
    return <Container>{this.renderPosibleOptions()}</Container>
  }
}

export default FlightSearchResult
